import React from 'react';
import { Link } from 'react-router-dom';

interface DailyTipsButtonProps {
  className?: string;
  onClick?: () => void;
}

const DailyTipsButton: React.FC<DailyTipsButtonProps> = ({ className = '', onClick }) => {
  return (
    <Link
      to="/daily-tips"
      className={`inline-flex items-center gap-2 px-4 py-2 rounded font-medium transition-colors ${className}`}
      style={{
        backgroundColor: '#111827',
        color: 'white',
        border: '1px solid #374151',
      }}
      title="View today's curated tips from Tippa"
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#1f2937';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '#111827';
      }}
    >
      Daily Tips
    </Link>
  );
};

export default DailyTipsButton;
